import React from "react";
import { FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";

import { useEventCalendarValues } from "../../../routes/calendar/calendar-context";

const formatHourLabel = (hour: number) => {
  if (hour === 24) {
    return "12 AM";
  }

  const suffix = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12} ${suffix}`;
};

const startHourOptions = Array.from({ length: 24 }, (_, hour) => hour);
const endHourOptions = Array.from({ length: 24 }, (_, index) => index + 1);

const FocusTimeFilter: React.FC = () => {
  const { focusStartHour, focusEndHour, updateFocusHours } = useEventCalendarValues();

  return (
    <Stack direction="row" spacing={1.25}>
      <FormControl fullWidth size="small">

        <Select
          value={focusStartHour}
          onChange={(event) => updateFocusHours(Number(event.target.value), focusEndHour)}
          sx={{
            borderRadius: 2,
            backgroundColor: "#FFFFFF",
          }}
        >
          {startHourOptions.map((hour) => (
            <MenuItem key={hour} value={hour}>
              {formatHourLabel(hour)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
        <Typography variant="caption" color="text.secondary" sx={{ pt: 1 }}>
          TO
        </Typography>
      <FormControl fullWidth size="small">
        <Select
          value={focusEndHour}
          onChange={(event) => updateFocusHours(focusStartHour, Number(event.target.value))}
          sx={{
            borderRadius: 2,
            backgroundColor: "#FFFFFF",
          }}
        >
          {endHourOptions.map((hour) => (
            <MenuItem key={hour} value={hour}>
              {formatHourLabel(hour)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default FocusTimeFilter;